import React, { useState } from 'react';

export default function QuestPanel({ emit, gameState, playerId, roleInfo, hasPlayed }) {
  const [submitting, setSubmitting] = useState(false);
  const [played, setPlayed] = useState(false);

  if (!gameState || gameState.phase !== 'quest') return null;

  const onTeam = gameState.proposedTeam.includes(playerId);
  const actuallyPlayed = hasPlayed || played;

  if (!onTeam) {
    return (
      <div className="waiting-state">
        <div className="waiting-icon">{'\u2694'}</div>
        Quest in progress...
        <div className="text-muted mt-8" style={{ fontSize: '0.8rem' }}>
          {gameState.questCardsSubmitted} / {gameState.proposedTeam.length} cards played
        </div>
      </div>
    );
  }

  if (actuallyPlayed) {
    return (
      <div className="vote-submitted">
        <span className="checkmark">{'\u2713'}</span>
        Quest card played! Waiting for team...
        <div className="text-muted mt-8" style={{ fontSize: '0.8rem' }}>
          {gameState.questCardsSubmitted} / {gameState.proposedTeam.length} cards played
        </div>
      </div>
    );
  }

  const isEvil = roleInfo?.alignment === 'evil';

  const handlePlay = async (card) => {
    if (submitting || actuallyPlayed) return;
    setSubmitting(true);
    const res = await emit('player:questCard', { card });
    setSubmitting(false);
    if (res.success) {
      setPlayed(true);
    }
  };

  return (
    <div className="quest-panel">
      <div className="text-center mb-8">
        <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>You are on this quest!</div>
        <div className="text-muted mt-8">Choose your quest card</div>
      </div>
      <div className="quest-buttons">
        <button
          className="btn btn-success-card"
          onClick={() => handlePlay('success')}
          disabled={submitting}
        >
          Success
        </button>
        {isEvil && (
          <button
            className="btn btn-fail-card"
            onClick={() => handlePlay('fail')}
            disabled={submitting}
          >
            Fail
          </button>
        )}
      </div>
      {!isEvil && (
        <div className="text-muted" style={{ fontSize: '0.8rem' }}>
          As a loyal servant, you must play Success
        </div>
      )}
    </div>
  );
}
